export enum PaymentReportEnum {
  OVERVIEW = 'OVERVIEW',
  BY_USER = 'BY_USER',
}
